export default function getMetaResourceTemplate(
  metaTemplateDefs,
  name,
  reducer,
) {
  // TODO: we could make a class to encapsulate with helpers and do a typeof here instead
  if (!Array.isArray(metaTemplateDefs)) throw new Error(`metaTemplateDefs must be an array, got: ${typeof meta}`);

  const definition = metaTemplateDefs.find(def => def.name === name);
  if (!definition) {
    throw new Error(
      `Meta Template Definition for ${name} doesn't not exist\nValid options ${metaTemplateDefs
        .map(def => def.name)
        .join(',')}`,
    );
  }

  return reducer(definition);
}
